import React from 'react';
import { Route, RouteProps, Switch } from 'react-router-dom';
import { MaintenanceConfig, Splits } from './types/split.type';
import {
    Adjustments,
    Auth,
    CheckoutInstructions,
    GettingThere,
    InTheHome,
    Maintenance,
    ManageGuestConfirmation,
    ModifyGuests,
    ModifyTrip,
    PaymentConfirmationAdjustment,
    Receipt,
    RentalAgreement,
    Reservation,
    VehicleRegistration,
    PaymentConfirmation,
} from './views';
import { requiredAuth } from './auth';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { Payment } from './views/payment/Payment';
import { ExtendedStay } from './views/extended-stay/ExtendedStay';
import { ModifyPets } from './views/modify/ModifyPets';
import { Cancellation } from './views/adjustments/Cancellation';
import { useFeatureConfig } from './services/optimizely/optimizelyHelper';

const NotFound: React.FC = () => <h1>404 NOT FOUND</h1>;

export enum AppRoutes {
    AUTH = '/trip/auth',
    RESERVATION = '/trip/reservation',
    GETTING_THERE = '/trip/getting-there',
    IN_THE_HOME = '/trip/in-the-home',
    RENTAL_AGREEMENT = '/trip/rental-agreement',
    VEHICLE_REGISTRATION = '/trip/vehicle-registration',
    CHECKOUT_INSTRUCTIONS = '/trip/checkout-instructions',
    MODIFY_TRIP = '/trip/modify-trip',
    MODIFY_TRIP_ADJUSTMENTS = '/trip/modify-trip/:adjustment',
    MODIFY_GUESTS = '/trip/modify-guests',
    MODIFY_PETS = '/trip/modify-pets',
    MODIFY_CONFIRMATION = '/trip/modify-confirmation',
    CANCEL = '/trip/cancel',
    PAYMENT = '/trip/payment',
    PAYMENT_THANK_YOU = '/trip/payment/thank-you',
    PAYMENT_SUCCESSFUL = '/trip/payment/success',
    RECEIPT = '/trip/receipt',
    EXTENDED_STAY = '/trip/extend_stay',
}

const routes: RouteProps[] = [
    { path: AppRoutes.AUTH, exact: true, component: Auth },
    { path: AppRoutes.RESERVATION, exact: true, component: requiredAuth(Reservation) },
    { path: AppRoutes.MODIFY_TRIP_ADJUSTMENTS, exact: true, component: requiredAuth(Adjustments) },
    { path: AppRoutes.CANCEL, exact: true, component: requiredAuth(Cancellation) },
    { path: AppRoutes.GETTING_THERE, exact: true, component: requiredAuth(GettingThere) },
    { path: AppRoutes.IN_THE_HOME, exact: true, component: requiredAuth(InTheHome) },
    { path: AppRoutes.RENTAL_AGREEMENT, exact: true, component: requiredAuth(RentalAgreement) },
    { path: AppRoutes.VEHICLE_REGISTRATION, exact: true, component: requiredAuth(VehicleRegistration) },
    { path: AppRoutes.MODIFY_TRIP, exact: true, component: requiredAuth(ModifyTrip) },
    { path: AppRoutes.CHECKOUT_INSTRUCTIONS, exact: true, component: requiredAuth(CheckoutInstructions) },
    { path: AppRoutes.MODIFY_GUESTS, exact: true, component: requiredAuth(ModifyGuests) },
    { path: AppRoutes.MODIFY_PETS, exact: true, component: requiredAuth(ModifyPets) },
    { path: AppRoutes.PAYMENT, exact: true, component: requiredAuth(Payment) },
    { path: AppRoutes.PAYMENT_SUCCESSFUL, exact: true, component: requiredAuth(PaymentConfirmationAdjustment) },
    { path: AppRoutes.PAYMENT_THANK_YOU, exact: true, component: requiredAuth(PaymentConfirmation) },
    { path: AppRoutes.MODIFY_CONFIRMATION, exact: true, component: requiredAuth(ManageGuestConfirmation) },
    { path: AppRoutes.RECEIPT, exact: true, component: requiredAuth(Receipt) },
    { path: AppRoutes.EXTENDED_STAY, exact: true, component: requiredAuth(ExtendedStay) },
    { path: '', exact: true, component: requiredAuth(Reservation) },
    { path: '*', component: NotFound },
];

export const Routes = () => {
    const { isEnabled: isMaintenanceEnabled, config: maintenanceConfig } = useFeatureConfig<MaintenanceConfig>(
        Splits.GUESTS_PORTAL_MAINTENANCE,
        true
    );

    const pagesMaintenance = maintenanceConfig?.pages;

    return (
        <React.Fragment>
            <ScrollToTop />
            <Switch>
                {routes.map((route, i) => {
                    const path = String(route.path);
                    const pageMaintenance = pagesMaintenance && pagesMaintenance.indexOf(path);
                    if (isMaintenanceEnabled && pageMaintenance && pageMaintenance >= 0) route.component = Maintenance;
                    return <Route key={i} {...route} />;
                })}
            </Switch>
        </React.Fragment>
    );
};
